"use client";

// The shell lives in `@/components/ui/filters` so the talent-search and
// pipeline panels share one text field; kept here as a re-export for the search
// sections that already import it.
export {
  FilterTextInput,
  type FilterTextInputProps,
} from "@/components/ui/filters";
